var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-container',[_c('v-card-title',[_c('h1',{staticClass:"component-header",domProps:{"innerHTML":_vm._s(
          _vm.$t('home.description.headline') != 'home.description.headline'
            ? _vm.$t('home.description.headline')
            : ''
        )}})]),_c('v-card-text',{class:'text-center'},[_c('p',{staticClass:"mb-0",staticStyle:{"font-size":"18px"},domProps:{"innerHTML":_vm._s(_vm.$t('home.description.text'))}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }